<div [class.ng-hide]="!isCurrent"
     class="flex flex-column flex-grow"
     [id]="'checkout-step-' + name">
    <ng-content />
    <!-- shipping method  tray -->
    <fast-checkout-shipping-methods-tray [checkoutFormComponent]="checkoutFormComponent"
                                         [checkoutStepComponent]="checkoutStepComponent"
                                         class="pos-fixed bg-col-w top-0 bottom-0 right-0 block ng-hide ng-hide-animate shipping-method-tray" />
</div>

<giftbox-introduction-tray class="giftbox-tray pos-fixed bg-col-w top-0 bottom-0 right-0 block ng-hide ng-hide-animate" />

<giftbox-form-tray [checkoutFormComponent]="checkoutFormComponent"
                   class="giftbox-tray pos-fixed bg-col-w top-0 bottom-0 right-0 block ng-hide ng-hide-animate" />

<basket-klarna-tray class="giftbox-tray pos-fixed bg-col-w top-0 bottom-0 right-0 block ng-hide ng-hide-animate" />